const MAX_MESSAGE_LENGTH = 500;
const LIST_PAGE_SIZE = 15;

export { LIST_PAGE_SIZE, MAX_MESSAGE_LENGTH };
